export const URL = process.env.REACT_APP_URL;
export const URL_LIVE = process.env.REACT_APP_LIVE;
export const API_URL = process.env.REACT_APP_API_AFRODITA;
export const STORAGE = process.env.REACT_APP_STORAGE_URL;
export const STREAMING = process.env.REACT_APP_STREAMING_URL;
export const WEBSOCKET = process.env.REACT_APP_WEBSOCKET;
// El backend publica el broadcasting por una conexión de Redis sin prefijo
// (config/database.php -> connections.broadcasting), de modo que el nombre del
// canal es el mismo en Laravel, en el servidor de sockets y aquí. Antes había
// que repetir el prefijo de Redis en el cliente, y eso hacía imposibles los
// canales privados y de presencia, cuyo nombre empieza por `private-`/
// `presence-`. Se mantiene la variable por si un despliegue conserva el
// prefijo antiguo.
export const BROADCAST_PREFIX = process.env.REACT_APP_BROADCAST_PREFIX ?? '';

export const getHeaders = () => {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
}

export const getHeaderToken = () => {
    const storedUser = localStorage.getItem("user");
    const token = storedUser ? JSON.parse(storedUser).token : null;
    return {
        Authorization: 'Bearer ' + token
    }
}

export const getHeadersWithToken = () => {

    return {
        ...getHeaders(),
        ...getHeaderToken()
    }
}

/**
 * Respuesta de la API, o un error legible.
 *
 * Cuando Laravel rechaza un formulario responde 422 con el detalle por campo
 * en `errors`, pero `message` es siempre el mismo texto genérico ("The given
 * data was invalid"). Al quedarse solo con `message`, la interfaz enseñaba un
 * aviso que no decía nada y el usuario solo veía que sus cambios no se
 * guardaban, sin llegar a saber qué campo los estaba bloqueando.
 *
 * El detalle se conserva además en `error.errors` para que un formulario pueda
 * señalar el campo concreto.
 */
export const responseJson = async (response)=>{
    const result = await response.json();

    if (!response.ok) {
        const fields = result?.errors ? Object.values(result.errors).flat() : [];

        const error = new Error(
            fields.length
                ? fields.join(' ')
                : (result?.message || result?.error || response?.statusText)
        );
        error.status = response.status;
        error.errors = result?.errors ?? null;

        throw error;
    }

    return result?.data;
}

